import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import "../styles/WhatsAppWidget.css"

const WHATSAPP_NUMBER = "918610087163"; // no + sign
const DEFAULT_MSG = "Hi, I'm visiting your online store and need some help";

const WhatsAppWidget = ({ inNavbar }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const openWhatsApp = () => {
    const msg = encodeURIComponent(DEFAULT_MSG);
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {/* Desktop Floating Button */}
      {!inNavbar && !isMobile && (
        <button
          className="whatsapp-fab"
          aria-label="Chat on WhatsApp"
          onClick={openWhatsApp}
        >
          <FaWhatsapp size={27} />
        </button>
      )}

      {/* Mobile Navbar Icon */}
      {inNavbar && isMobile && (
        <button
          className="whatsapp-navbar"
          aria-label="Chat on WhatsApp"
          onClick={openWhatsApp}
          style={{
            background: "none",
            border: "none",
            padding: "0 6px",
            cursor: "pointer",
          }}
        >
          <FaWhatsapp size={23} style={{ color: "#25d366" }} />
        </button>
      )}
    </>
  );
};

export default WhatsAppWidget;
